/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackingQualityDailyData
 */
export interface TrackingQualityDailyData {
    /**
     * 
     * @type {Date}
     * @memberof TrackingQualityDailyData
     */
    date?: Date;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityDailyData
     */
    entryEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityDailyData
     */
    updateEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityDailyData
     */
    orderEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityDailyData
     */
    pairedOrderEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityDailyData
     */
    erpOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityDailyData
     */
    uniqueVisitors?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityDailyData
     */
    uniqueOrderingVisitors?: number;
}

/**
 * Check if a given object implements the TrackingQualityDailyData interface.
 */
export function instanceOfTrackingQualityDailyData(value: object): value is TrackingQualityDailyData {
    return true;
}

export function TrackingQualityDailyDataFromJSON(json: any): TrackingQualityDailyData {
    return TrackingQualityDailyDataFromJSONTyped(json, false);
}

export function TrackingQualityDailyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingQualityDailyData {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'entryEvents': json['entryEvents'] == null ? undefined : json['entryEvents'],
        'updateEvents': json['updateEvents'] == null ? undefined : json['updateEvents'],
        'orderEvents': json['orderEvents'] == null ? undefined : json['orderEvents'],
        'pairedOrderEvents': json['pairedOrderEvents'] == null ? undefined : json['pairedOrderEvents'],
        'erpOrders': json['erpOrders'] == null ? undefined : json['erpOrders'],
        'uniqueVisitors': json['uniqueVisitors'] == null ? undefined : json['uniqueVisitors'],
        'uniqueOrderingVisitors': json['uniqueOrderingVisitors'] == null ? undefined : json['uniqueOrderingVisitors'],
    };
}

export function TrackingQualityDailyDataToJSON(json: any): TrackingQualityDailyData {
    return TrackingQualityDailyDataToJSONTyped(json, false);
}

export function TrackingQualityDailyDataToJSONTyped(value?: TrackingQualityDailyData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'entryEvents': value['entryEvents'],
        'updateEvents': value['updateEvents'],
        'orderEvents': value['orderEvents'],
        'pairedOrderEvents': value['pairedOrderEvents'],
        'erpOrders': value['erpOrders'],
        'uniqueVisitors': value['uniqueVisitors'],
        'uniqueOrderingVisitors': value['uniqueOrderingVisitors'],
    };
}

